import React, {Fragment} from 'react';
import nophoto from "../../assets/img/nophoto.png";
import {Link} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import swal from 'sweetalert';
import {
    acceptConnectionRequest,
    rejectConnectionRequest, removeConnectionRequest,
    sendConnectionRequest, setDataInRedux
} from "../../actions/profile";

const CommanAgentCard = ({role, avatar, name, phone, email, key, is_online, userId, loggedinId, properties, friends, country, state, city, experience, sentRequests, receivedRequests, blockedFriends, sendConnectionRequest, rejectConnectionRequest, acceptConnectionRequest, removeConnectionRequest, setDataInRedux, user}) => {

    const setDataReduxChat = () => {
        const req = {
            _id: userId,
            name: name,
            image: avatar,
            is_online: is_online,

        };
        setDataInRedux(req);
    };

    //console.log((userId !== loggedinId),"userId !== loggedinId");
    //console.log(user,"user");
    //console.log(userId,email,"userId");
    //console.log(user.sentRequests,"useruser.sentRequests");
    //console.log(user.receivedRequests,"useruser.receivedRequests");
    return (
        <Fragment>
            {role !== "Admin" &&
            <div className="row">
                <div className="list mt-3 w-75 mx-auto d-inline-flex row">
                    <div className="col-lg-4 col-xl-4 col-md-3 col-12 mt-3">
                        <img className="user-avatar" src={avatar} alt={nophoto}/>
                    </div>
                    <div className="col-lg-7 col-xl-7 col-md-7 col-12">
                        <h5>{name} - <span className="badge badge-pill badge-secondary">{role}</span></h5>
                        <p className="fax text-dark message"><i
                            className="fa fa-envelope mr-1"/>{email}</p>
                        <p className="mt5">
                            Address: {`${city ? city : ''}-${state ? state : ''}-${country ? country : ''}`}
                        </p>
                        <p>
                            Experience: {experience}
                        </p>
                        <p>
                            Properties:-
                            <p className="badge badge-light">
                                Total: {properties ? properties : 0}</p>
                        </p>
                        {(user.receivedRequests && user.receivedRequests.find(d => d === userId)) || (user.sentRequests && user.sentRequests.find(d => d === userId)) || (user.friends && user.friends.find(d => d === userId)) || (userId === loggedinId) ? '' :
                            <Link to="/" className={'btn text-warning bg-white mt-2'} onClick={(e) => {
                                e.preventDefault();
                                sendConnectionRequest(loggedinId, userId)

                            }
                            }> <span className="badge badge-info p-2"><i
                                className="fa fa-user-plus"/> Connect Now</span></Link>}

                        {((user.receivedRequests && user.receivedRequests.find(id => (id === userId))) && (userId !== loggedinId)) &&
                        <Fragment>
                            <Link to="/" className={'btn text-success 2 mt-2 bg-white '} onClick={(e) => {
                                e.preventDefault();
                                acceptConnectionRequest(loggedinId, userId)
                            }}> <span className="badge badge-success p-2"><i
                                className="fa fa-check"/> Accept</span></Link>

                            <Link to="/" className={'btn text-danger 2 bg-white mt-2'} onClick={(e) => {
                                e.preventDefault();

                                swal({
                                    title: "Are you sure?",
                                    text: "Cancel received connection request..!",
                                    icon: "warning",
                                    buttons: true,
                                    dangerMode: true,
                                })
                                    .then((willDelete) => {
                                        if (willDelete) {
                                            rejectConnectionRequest(loggedinId, userId);
                                            swal("Poof! Cancel received connection Request..!", {
                                                icon: "success",
                                            });

                                        } else {
                                            swal("You received connection request is not cancelled..!");
                                        }
                                    });


                            }}> <span className="badge badge-danger p-2"> <i
                                className="fa fa-times"/> Cancel</span></Link></Fragment>}


                        {user.sentRequests && user.sentRequests.find(d => d === userId) &&
                        <Fragment>
                            <Link to="/" className={'btn text-danger 2 bg-white mt-2'} onClick={(e) => {
                                e.preventDefault();

                                swal({
                                    title: "Are you sure?",
                                    text: "Cancel sent connection request..!",
                                    icon: "warning",
                                    buttons: true,
                                    dangerMode: true,
                                })
                                    .then((willDelete) => {
                                        if (willDelete) {
                                            rejectConnectionRequest(loggedinId, userId);
                                            swal("Poof! You Sent connection request is cancelled..!", {
                                                icon: "success",
                                            });

                                        } else {
                                            swal("You Sent connection request is not cancelled..!");
                                        }
                                    });


                            }}><span className="badge badge-danger p-2"> <i
                                className="fa fa-times"/> Cancel</span></Link>
                        </Fragment>
                        }

                        {(user.friends && user.friends.find(id => (id === userId))) && (userId !== loggedinId) &&
                        <Fragment>
                            <Link to={`/private-chat`} onClick={() => setDataReduxChat()}
                                  className={'btn text-success 2 mt-2 bg-white '}>
                                <span className="badge badge-success p-2"><i className="fas fa-comment"/> Message</span></Link>
                            <Link to="/" className={'btn text-danger 2 bg-white mt-2'} onClick={(e) => {
                                e.preventDefault();

                                swal({
                                    title: "Are you sure?",
                                    text: "Are you sure want to remove this connection ?",
                                    icon: "warning",
                                    buttons: true,
                                    dangerMode: true,
                                })
                                    .then((willDelete) => {
                                        if (willDelete) {
                                            removeConnectionRequest(loggedinId, userId);
                                            swal("Poof! You remove this connection..!", {
                                                icon: "success",
                                            });

                                        } else {
                                            swal("Your connection is safe..!");
                                        }
                                    });


                            }}> <span className="badge badge-danger p-2"><i
                                className="fas fa-times"/> Remove</span></Link>
                        </Fragment>
                        }
                        {userId === loggedinId &&
                        <Link to={`/user-profile`} className={'btn text-primary bg-white mt-2'}>
                            <span className="badge badge-primary p-2"><i className="fas fa-user"/> Your Profile</span>
                        </Link>}
                    </div>
                </div>
            </div>}
        </Fragment>
    )
        ;
};

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.isAuthenticated,
        user: state.auth.user
    };
};
export default connect(mapStateToProps, {
    sendConnectionRequest,
    rejectConnectionRequest,
    acceptConnectionRequest,
    removeConnectionRequest,
    setDataInRedux
})(CommanAgentCard);